import BaseController from "ips/ac/controller/scfld/BaseController";
import ODataMixin from "ips/ac/controller/scfld/mixin/ODataMixin";
import SmarterTable from "ips/ac/syscon/SmarterTable";
import Button, { Button$PressEvent } from "sap/m/Button";
import { ListBase$UpdateFinishedEvent } from "sap/m/ListBase";
import Table from "sap/m/Table";
import JSONModel from "sap/ui/model/json/JSONModel";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";

/** foreign key of a new component, depending on the entity set of the parent object page */
const PARENT_FOREIGN_KEYS: Record<string, string> = {
  Projects: "ProjectGuid",
  Products: "ProductGuid",
};

/**
 * Component table of a project or product, embedded as sub view of the parent object page.
 * @namespace ips.ac.controller.component
 */
export default class ComponentDetails extends BaseController {

  private _oViewModel: JSONModel;
  private _oODataModel: ODataModel;

  /* =========================================================== */
  /* lifecycle methods                                           */

  /* =========================================================== */

  public onInit(): void {
    // add used mixins
    ODataMixin.addTo(this);

    // Model used to manipulate control states. The chosen values make sure,
    // detail page is busy indication immediately so there is no break in
    // between the busy indication for loading the view's meta data
    const oViewModel = new JSONModel({
      listCount: null,
    });
    this.setModel(oViewModel, "ui");
    this._oViewModel = oViewModel;

    // oData model
    this._oODataModel = this.getODataModel();
    this._bindComponentTable();
    new SmarterTable(this, "componentDetails", "", []);
  }

  /* =========================================================== */
  /* event handler                                               */

  /* =========================================================== */

  public onUpdateFinished(oEvent: ListBase$UpdateFinishedEvent): void {
    const iTotal = oEvent.getParameter("total"),
      oList = this.byId("componentDetails") as Table;

    // only update the counter if the length is final
    if (oList && (oList.getBinding("items") as ODataListBinding).isLengthFinal()) {
      //sTitle = this.getResourceBundle().getText("masterTitleCount", [iTotalItems]);
      //this._oViewModel.setProperty("/title", sTitle);
      this._oViewModel.setProperty("/listCount", iTotal);
    }
  }

  /**
   * Event handler  (attached declaratively) called when the add button in the master view is pressed. it opens the create view.
   * @param {sap.ui.base.Event} oEvent - the navigate to event.
   * @public
   */
  public onComponentAdd(oEvent: Button$PressEvent): void {
    const oButton = oEvent.getSource() as Button;
    oButton.data("routeName", "componentedit");

    // the sub view inherits the binding context of the parent object page (project or product);
    // read it on press, so it always belongs to the currently displayed parent
    const oParentContext = this.getView().getBindingContext();
    const sEntitySet = oParentContext?.getPath().split("(")[0].substring(1);
    const sForeignKey = PARENT_FOREIGN_KEYS[sEntitySet];
    if (sForeignKey) {
      oButton.data("entityDefaults", {
        [sForeignKey]: oParentContext.getProperty("Guid") as string,
      });
    }

    // call origin
    this.onAdd(oEvent);
  }

  private _bindComponentTable(): void {
    const oComponentDetailsTable = this.byId("componentDetails") as Table;
    oComponentDetailsTable.bindItems(this._validateParametersFromConfig({
      path: "ComponentDetails",
      parameters: { $$ownRequest: true },
      templateShareable: true,
      template: this.getItemTemplateFromControl(oComponentDetailsTable),
    }));
  }
}
